import { EChainType } from '@/constants/chains'

import { isBtcChain, isEvmChain, isSolanaChain } from './chain'

export function createReferralSignatureMessage(walletAddress = '', referralCode = '', timestamp: number): string {
  return (
    `Please sign this message to confirm linking your wallet ${walletAddress} ` +
    `with referral code ${referralCode}.\n` +
    `Timestamp: ${timestamp}`
  )
}
export function createRewardClaimMessage(walletAddress: string, timestamp: number): string {
  return `Claim reward for wallet ${walletAddress} at ${timestamp}`
}

export function getChainType(networkId: string): EChainType | undefined {
  if (isBtcChain(networkId)) return EChainType.BTC
  if (isSolanaChain(networkId)) return EChainType.SOLANA
  if (isEvmChain(networkId)) return EChainType.EVM
  return undefined
}
